import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import styled from 'styled-components';
import SvgIcon from './SvgIcon';
import { ICON_LARGE_SIZE, ICON_SIZE } from '../constants';
import IconWrapper from './components/IconWrapper';
import { getDefined } from '../helpers/common';
import { useDeviceType } from '../hooks';
import { absoluteCenteredStyle } from '../tokens/centered';
import { getIcon, getIconColor, getIconHoverColor } from '../helpers/icons';
const Wrapper = styled(IconWrapper)`
  & > * {
    ${absoluteCenteredStyle}
  }
`;
const IconDefault = /*#__PURE__*/React.forwardRef(({
  flex = true,
  disabled = false,
  inactive = false,
  hasArrow = false,
  hasClose = false,
  icon,
  color,
  colorHover,
  colorActive,
  arrow = 'right',
  pointer = false,
  className,
  size,
  style,
  ...props
}, forwardedRef) => {
  const {
    hasTouchScreen
  } = useDeviceType();
  return /*#__PURE__*/React.createElement(Wrapper, {
    ref: forwardedRef,
    flex: flex,
    pointer: pointer,
    disabled: disabled,
    inactive: inactive,
    className: className,
    style: style
  }, /*#__PURE__*/React.createElement(SvgIcon, _extends({
    flex: true,
    size: size ?? (hasArrow ? ICON_LARGE_SIZE : ICON_SIZE),
    color: getDefined(color, getIconColor(disabled)),
    colorHover: hasTouchScreen ? null : getDefined(colorHover, colorActive, getIconHoverColor(disabled))
  }, props), icon || getIcon(hasArrow, hasClose, arrow)));
});
export default IconDefault;